module.exports = __webpack_public_path__ + "img/AdobeStock_265794447.07d844f5.jpeg";